import FormTag from "./components/FormTag.vue";
import FormInput from "./components/FormInput.vue";
import FormSelect from "./components/FormSelect.vue";
import FormDate from "./components/FormDate.vue";
import FormNumber from "./components/FormNumber.vue";
import FormRadio from "./components/FormRadio.vue";
import FormSwitch from "./components/FormSwitch.vue";
import FormCheckbox from "./components/FormCheckbox.vue";
import type { App } from "vue";

export default {
  install(app: App): void {
    app.component(FormTag.name, FormTag);
    app.component(FormInput.name, FormInput);
    app.component(FormSelect.name, FormSelect);
    app.component(FormDate.name, FormDate);
    app.component(FormNumber.name, FormNumber);
    app.component(FormRadio.name, FormRadio);
    app.component(FormSwitch.name, FormSwitch);
    app.component(FormCheckbox.name, FormCheckbox);
  }
};
